import { Outlet } from 'react-router-dom';
import OfflineBanner from '../OfflineBanner';
import ImpersonationBanner from './ImpersonationBanner';

const PosLayout = () => (
  <div className="flex h-screen flex-col overflow-hidden bg-zinc-100 dark:bg-zinc-950">
    <OfflineBanner />
    <ImpersonationBanner />
    <main className="min-h-0 flex-1 overflow-hidden">
      <Outlet />
    </main>
  </div>
);

export default PosLayout;
